<template>
  <div :class="[ isMobile ? 'mobile-container' : '' ]">
    <Render :value="value" :isMobile="isMobile" :env="env" />
  </div>
</template>
<script>
import AmisRender from './AmisRender'
import { ReactInVue } from "vuera"
import 'amis-editor-core/lib/style.css'
import 'amis/lib/themes/default.css'

export default {
  name: 'AmisPreviewer',
  components: {
    Render: ReactInVue(AmisRender)
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    env: {
      type: Object
    }
  }
}
</script>
<style lang="less" scoped>
.mobile-container {
  display: block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  border-width: 64px 22px;
  border-color: #ddd;
  border-style: solid;
  border-radius: 40px;
  width: 419px;
  height: 100%;
  flex-grow: unset;
  min-height: unset;
  margin: 20px auto;
  min-width: unset;
  padding: 0;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: auto;
}

.mobile-container::-webkit-scrollbar {
  display: none;
}
</style>